import { Component } from "react";
import { Form, Col, Row } from "react-bootstrap";

import { deepEqual } from "../../utils/object";
import StateSelect, { exists as StateValid } from "../select/state";
import CountySelect, { exists as CountyValid } from "../select/county";

class Jurisdiction extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...this.mapPropsToState(props),
        };
    }

    mapPropsToState = (props = {}) => {
        return {
            city: props.city ?? "",
            county: props.county ?? "",
            state: props.state ?? "",
        };
    };

    componentDidUpdate = (oldProps) => {
        const oldSlice = this.mapPropsToState(oldProps);
        const newSlice = this.mapPropsToState(this.props);

        if (!deepEqual(oldSlice, newSlice)) {
            this.setState({ ...newSlice });
        }
    };

    doPostChange = () => {
        this.props.onChange?.({ ...this.state });
    };

    onStateChange = (value) => {
        const v = value ?? "";
        if (!StateValid(v)) return;

        this.setState(
            {
                state: v,
                county: "",
            },
            this.doPostChange
        );
    };

    onCountyChange = (value) => {
        const v = value ?? "";
        if (!v) {
            this.setState({ county: "" }, this.doPostChange);
            return;
        }

        if (CountyValid(this.state.state, v)) {
            this.setState({ county: v }, this.doPostChange);
        }
    };

    copyToClipboard = async (content) => {
        try {
            await navigator.clipboard.writeText(content ?? "");
        } catch (error) {
        }
    };

    onChange = (e) => {
        this.setState(
            {
                [e.target.name]: e.target.value,
            },
            this.doPostChange
        );
    };

    render() {
        return (
            <>
                <Row className={this.props.rowClassName}>
                    <Col lg="5">
                        <div className="mb-3 top-label">
                            <Form.Control
                                value={this.state.city || ""}
                                type="text"
                                name="city"
                                onChange={this.onChange}
                            />
                            <Form.Label
                                style={{ cursor: "copy" }}
                                onClick={() => this.copyToClipboard(this.state.city)}
                            >
                                CITY
                            </Form.Label>
                        </div>
                    </Col>

                    <Col lg="3">
                        <div className="mb-3 top-label">
                            <StateSelect
                                value={this.state.state || ""}
                                onChange={this.onStateChange}
                                placeholder=""
                                name="state"
                            />
                            <Form.Label>STATE</Form.Label>
                        </div>
                    </Col>

                    <Col lg="4">
                        <div className="mb-3 top-label">
                            <CountySelect
                                value={this.state.county || ""}
                                state={this.state.state}
                                onChange={this.onCountyChange}
                                placeholder=""
                                name="county"
                            />
                            <Form.Label>COUNTY</Form.Label>
                        </div>
                    </Col>
                </Row>
            </>
        );
    }
}

export default Jurisdiction;